import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../redux/store'
import { getTypesPickingRouteActionAsync } from '../redux/actions/typePickingRouteActions'

export const useTypesPickingRoute = () => {
  const { typesPickingRouteState } = useSelector(
    (state: RootState) => state.typePickingRoute
  )
  const dispatch = useDispatch()

  const getTypesPickingRoute = () => {
    dispatch(getTypesPickingRouteActionAsync())
  }

  return { typesPickingRouteState, getTypesPickingRoute }
}
